import styled from "styled-components";
import { TitleDruk } from "@motain/web-shared-hub/ui/elements";

export const ErrorTitle = styled(TitleDruk).withConfig({
  shouldForwardProp: () => true,
})`
  color: #000;
  background-color: #fff;
  display: inline;
`;
